
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { ThemeConstantService } from './services/theme-constant.service';
import { SearchPipe } from './pipes/search.pipe';
import {ItemCountComponent} from './components/item-count/item-count.component';
import {HasAnyAuthorityDirective} from './directives';
import {CookieModule} from 'ngx-cookie';
import {IconFilterPipe} from './pipes/iconFilter.pipe';
import { SearchFilterComponent } from 'src/app/shared/components/search-filter/search-filter.component';
import { ErrorTextComponent } from 'src/app/shared/components/error-text/error-text.component';
import { ConfirmPopUpComponent } from 'src/app/shared/components/confirm-popup/confirm-popup.component';
import { TransformCustomDatePipe } from 'src/app/shared/pipes/transformCustomDate.pipe';
import { TransformMoneyPipe } from './pipes/transformMoney.pipe';
import { DropdownSearchComponent } from './components/dropdown-search/dropdown-search.component';
import { FilterReceiversComponent } from './components/filter-receivers/filter-receivers.component';
import { DetailMailSendComponent } from './components/detail-mail-send/detail-mail-send.component';
import { EditScheduleNotificationComponent } from './components/edit-schedule-notification/edit-schedule-notification.component';
import { AddLinkPopUpComponent } from '../modules/users/components/add-link-popup/add-link-popup.component';
import { IconNotificationPopUpComponent } from '../modules/users/components/icon-notificaiton-popup/icon-notificaiton-popup.component';
import { UserAuthorityDirective } from './directives/user-authority.directive';
import { ViewImageComponent } from './components/view-image/view-image';
import { FileUploadModule } from 'ng2-file-upload';
import { CustomEditorComponent } from '../modules/users/components/custom-editor/custom-editor.component';
import { AutoCompleteComponent } from './components/auto-complete/auto-complete.component';
import { FilterStartEndDateComponent } from './components/filter-start-end-date/filter-start-end-date';
import { AddProductPopUpComponent } from '../modules/users/components/add-product-popup/add-product-popup.component';

import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzPageHeaderModule } from 'ng-zorro-antd/page-header';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzSelectModule  } from 'ng-zorro-antd/select';
import { NzSliderModule  } from 'ng-zorro-antd/slider';
import { NzTableModule  } from 'ng-zorro-antd/table';
import { NzTabsModule  } from 'ng-zorro-antd/tabs';
import { NzAvatarModule  } from 'ng-zorro-antd/avatar';
import { NzAlertModule  } from 'ng-zorro-antd/alert';
import { NzProgressModule  } from 'ng-zorro-antd/progress';
import { NzToolTipModule   } from 'ng-zorro-antd/tooltip';
import { NzPopoverModule    } from 'ng-zorro-antd/popover';
import { NzSwitchModule   } from 'ng-zorro-antd/switch';
import { InputNumberComponent } from './components/input-number/input-number';
import { InputDateComponent } from './components/input-date/input-date';
import { InputDatePickerAndTimeComponent } from './components/input-datepicker-and-time/input-datepicker-and-time';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { OTPComponent } from './components/otp/otp.component';
import { ClipboardModule } from 'ngx-clipboard';
import { NewPagingComponent } from './components/new-paging/new-paging.component';
import { AddEmailComponent } from './components/add-email/add-email.component';

@NgModule({
    imports: [
        RouterModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        FileUploadModule,
        NzIconModule,
        NzTagModule,
        NzBadgeModule,
        NzModalModule,
        NzCardModule,
        NzTabsModule,
        NzListModule,
        NzPageHeaderModule,
        NzFormModule,
        NzLayoutModule,
        NzDropDownModule,
        NzButtonModule,
        NzSelectModule,
        NzSliderModule,
        NzSpinModule,
        NzTableModule,
        NzAvatarModule,
        NzInputModule,
        NzAlertModule,
        NzPaginationModule,
        NzProgressModule,
        NzToolTipModule,
        NzPopoverModule,
        NzSwitchModule,
        NzDividerModule,
        ClipboardModule,
        FileUploadModule,
        CookieModule.forRoot()
    ],
    declarations: [
        IconFilterPipe,
        SearchPipe,
        ItemCountComponent,
        ErrorTextComponent,
        HasAnyAuthorityDirective,
        SearchFilterComponent,
        ConfirmPopUpComponent,
        TransformCustomDatePipe,
        TransformMoneyPipe,
        DropdownSearchComponent, AutoCompleteComponent,
        FilterReceiversComponent,
        DetailMailSendComponent,
        EditScheduleNotificationComponent,
        IconNotificationPopUpComponent,
        AddLinkPopUpComponent, AddProductPopUpComponent,
        UserAuthorityDirective,
        ViewImageComponent, 
        CustomEditorComponent,
        FilterStartEndDateComponent,
        InputDateComponent,
        InputNumberComponent,
        InputDatePickerAndTimeComponent,
        OTPComponent,
        NewPagingComponent,
        AddEmailComponent
    ],
    exports: [
        CommonModule,
        FormsModule,
        HttpClientModule,
        ReactiveFormsModule,
        NzIconModule,
        NzTagModule,
        NzBadgeModule,
        NzModalModule,
        NzCardModule,
        NzTabsModule,
        NzListModule,
        NzPageHeaderModule,
        NzFormModule,
        NzLayoutModule,
        NzSpinModule,
        NzDropDownModule,
        NzButtonModule,
        NzSelectModule,
        NzTableModule,
        NzAvatarModule,
        NzInputModule,
        NzAlertModule,
        NzPaginationModule,
        NzProgressModule,
        NzToolTipModule,
        NzPopoverModule,
        NzSwitchModule,
        NzSliderModule,
        NzDividerModule,
        ClipboardModule,
        FileUploadModule,
        IconFilterPipe,
        SearchPipe,
        HasAnyAuthorityDirective,
        SearchFilterComponent,
        DropdownSearchComponent, AutoCompleteComponent,
        ErrorTextComponent,
        TransformCustomDatePipe,
        TransformMoneyPipe,
        FilterReceiversComponent,
        DetailMailSendComponent,
        EditScheduleNotificationComponent,
        IconNotificationPopUpComponent,
        AddLinkPopUpComponent,
        UserAuthorityDirective,
        ViewImageComponent,
        CustomEditorComponent,
        FilterStartEndDateComponent,
        InputDateComponent,
        InputNumberComponent,
        InputDatePickerAndTimeComponent,
        OTPComponent,
        NewPagingComponent,
        AddEmailComponent
    ],
    providers: [
        ThemeConstantService
    ]
})

export class SharedModule { }
